<script>
export default {
  props: {
    submit_btn_text: {
      type: String,
      required: true
    },
    typeOf: {
        type: String,
        required: true
    }
  }
}
  function handleSubmit() {
  }
</script>
<template>
<form 
  onsubmit={handleSubmit} 
  class="flex flex-col w-[34%] max-md:ml-0 max-md:w-full"
  dir="rtl"
  aria-label="טופס יצירת קשר"
>
<h2
v-if='typeOf != "contact_me"'
 class="text-5xl text-center font-bold bg-yellow-300 text-violet-800 tracking-wide relative inline-block">
  {{submit_btn_text}}
</h2>
  <div class="flex flex-col mt-3 text-xl leading-tight text-right text-violet-800 whitespace-nowrap max-md:mt-10 space-y-2.5">
    <div class="relative">
      <label for="name" class="sr-only">שם</label>
      <input 
        type="text" 
        id="name"
        class="w-full px-16 py-2 bg-white rounded-3xl border border-violet-800 border-solid max-md:px-5 focus:outline-none focus:ring-2 focus:ring-violet-800"
        placeholder="שם"
        required
      />
    </div>

    <div class="relative">
      <label for="email" class="sr-only">מייל</label>
      <input 
        type="email" 
        id="email"
        class="w-full px-16 py-2 bg-white rounded-3xl border border-violet-800 border-solid max-md:px-5 focus:outline-none focus:ring-2 focus:ring-violet-800"
        placeholder="מייל"
        required
      />
    </div>

    <div class="relative" dir="ltr">
      <label for="phone" class="sr-only">טלפון</label>
      <input 
        type="tel" 
        id="phone"
        class="w-full px-16 py-2 text-right bg-white rounded-3xl border border-violet-800 border-solid max-md:px-5 focus:outline-none focus:ring-2 focus:ring-violet-800"
        placeholder="טלפון"
        required
      />
    </div>

    <button 
      type="submit"

      class="h-16 px-16 py-2 mt-3.5 text-xl font-bold text-center text-white rounded-3xl bg-violet-400  max-md:px-5 hover:bg-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-400 focus:ring-offset-2 transition-colors duration-300"
    >
   👈 {{submit_btn_text}} 👉
    </button>
  </div>
</form>
</template>
